import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 20px 24px 16px;
    background-color: transparent;
    gap: 16px;
  `}
`

export const Heading = styled.div`
  width: 100%;
`

export const CloseButton = styled.button`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    background-color: ${props => props.theme.colors.alternativeSecodary};
    color: ${props => props.theme.colors.text.secondary};
    transition: background-color 0.15s ease, transform 0.1s ease;

    &:hover {
      background-color: ${props => props.theme.colors.borderColorSecondary};
    }

    &:active {
      transform: scale(0.92);
    }
  `}
`
